import React from "react";
import { useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";

function GlobalLoading({ locale }) {
  const loading = useSelector((state) => state.feedback.loading) > 0;

  const show = useSelector((state) => state.feedback.show);

  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 2000 }}
            open={loading}
          >
            {show && (
              <Grid container sx={{ width: "100%" }}>
                <Grid item xs={12} align="center">
                  <CircularProgress color="inherit" />
                </Grid>
                <Grid item xs={12} align="center">
                  <Typography variant="h6" color="white">
                    {locale === "en"
                      ? "Please wait as we load your informations!"
                      : "Veuillez patienter pendant que nous chargeons vos informations!"}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Backdrop>
        </>
      )}
    </>
  );
}

export default GlobalLoading;
